import { useEffect, useState } from "react";
import FooterNav from "../components/FooterNav";
import I18n from "../components/I18n";
import { useLocale } from "../Locale";
import { trackPage } from '../adobeAnalytics';

const Partnerships = () =>{
    const [redirectTo, setRedirectTo] = useState(false); // your state value to manipulate
	const locale = useLocale()
	useEffect(() => {
		trackPage(`${locale}|partnerships`, 'partnerships');
        if(locale === 'en') {
            window.modalComponent.init();
        }
	}, [locale]);
    useEffect(() => {
        //check cookie
        const pageCookie = getCookie("visitedPartnership");
        if(pageCookie !== ""){
            if(pageCookie === "true"){
                setRedirectTo(true)
            }
        }else{
            setCookie("visitedPartnership", true, 1)
        }
      }, []);
    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
            c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    if(redirectTo){
        // return(
        //     <Redirect to="/discover" />
        // )
    }
    
    
    return(
        <div className={"container partnerships lang-" + locale}>
            <div className="hero" />
            <div className="content">
                <div className={"page-logo nissan-expo lang-" + locale}>NISSAN Expo 2020 Dubai UAE</div>
                <div className="content-text">
                    <h1><I18n t="partnership.subheadline" /></h1>
                    <h2><I18n t="partnership.headline" /></h2>
                    <p><I18n t="partnership.text" /></p>
                </div>
            </div>
            {locale === 'jp' ? 
            <FooterNav currentPage="partnerships" customClass="transparent"
                prev={{ text: 'partnership.ctaExternalLinkText', url: 'https://www.nissan.co.jp/', external: true }}
                next={{text:"partnership.ctaText", url:"experience"}}
            />
            : locale === 'en'?
            <FooterNav currentPage="partnerships" customClass="transparent"
                prev={{ text: 'partnership.ctaExternalLinkText', url: '#', explore: true }}
                next={{text:"partnership.ctaText", url:"experience"}}
            />
            :
            <FooterNav currentPage="partnerships" customClass="transparent"
                next={{text:"partnership.ctaText", url:"experience"}}
             />
            }
        </div>
    )
}

export default Partnerships;